"use client";

import React, { useState, useEffect } from "react";
import { enable2FA } from "../../services/digitalWalletService";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AuthenticateTwoFA from "../../components/AuthenticateTwoFA";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../hooks/use-toast";
import TwoFAQrCode from "../../components/QrCodeTwoFA";
import Toaster from "../../components/ui/toaster";
import Header from "../../layouts/Header";

const Settings2FA = () => {
  const [authenticate, setAuthenticate] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const { settings, updateSettings, refreshUser } = useAuth();
  const [mainSecret, setMainSecret] = useState(null);
  const [isEnabled, setIsEnabled] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  function onCancel() {
    navigate("/settings/security");
  }

  useEffect(() => {
    const enable = settings?.security?.twoFactorAuth?.enabled;
    setIsEnabled(enable);
    if (enable === true) {
      // Already enabled, redirect to security page
      navigate("/settings/security");
    }
  }, [settings, navigate]);

  const handleNext = (secret) => {
    setMainSecret(secret);
    setAuthenticate(true);
  };

  const handleBack = () => {
    setAuthenticate(false);
  };

  const handleVerify = async (token) => {
    setIsVerifying(true);
    try {
      const otpauthUrl = `otpauth://totp/80Eight?secret=${mainSecret}`;
      const twoFAdata = {
        token: token,
        secret: mainSecret,
        otpauthUrl: otpauthUrl,
      };
      const result = await enable2FA(twoFAdata);

      if (result) {
        if (result.status === 200) {
          updateSettings(result.data.data);
          await refreshUser();
          toast({
            description: "2FA enabled successfully",
            variant: "eighty",
          });
          navigate("/settings/security");
        }
      }
    } catch (error) {
      toast({
        description: `${error.message}`,
        variant: "eighty",
      });
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <>
      <Header />
      <Toaster />
      <div className="min-h-screen w-full bg-gray-100 flex flex-col">
        <div className="h-14 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center pl-20 text-white">
          <ArrowLeft
            className="mr-5 bg-transparent rounded-full p-1 border-gray-200/60 border hover:border-gray-400 hover:bg-white/20 cursor-pointer"
            onClick={() => {
              if (authenticate) {
                handleBack();
              } else {
                navigate("/settings/security");
              }
            }}
          />
          <span className="font-semibold text-lg">
            {authenticate
              ? "Verify 2FA Code"
              : "Enable 2-Factor Authentication"}
          </span>
        </div>
        <div className="flex justify-center mt-12 px-4 md:px-16 lg:px-32">
          <div className="max-w-3xl w-full">
            {isEnabled === false && authenticate === false && (
              <TwoFAQrCode onNext={handleNext} onCancel={onCancel} />
            )}
            {authenticate === true && isEnabled === false && (
              <AuthenticateTwoFA
                onVerify={handleVerify}
                onCancel={handleBack}
                isVerifying={isVerifying}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings2FA;
